import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAsyncError, useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import * as Yup from "yup";

const PayrollAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Payroll"));
  }, []);

  const [loading, setLoading] = useState(false);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    SalarySlipHead: "",
    PayrollType_054: null,
    AccountID: null,
    OnAttendance: 1,
    ShowZeroValue: 0,
    IsBasePayroll: 0,
    ComputeOnRange: false,
    ComputeOn: "",
    Formula: "",
    IsCalculatedOnRunTime: 0,
    RoundOffLevel_035: 278,
    RoundOffValue: (1).toFixed(2),
    Slabs: [],
  };


  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);

  const [payrollTypeOptions, setPayrollTypesOption] = useState([]);
  const [accountMastersOption, setAccountMastersOption] = useState([]);
  const [roundOffLeavesOption, setRoundOffLeavesOption] = useState([]);

  useEffect(() => {
    fetchDetailsApi();
  }, []);
  const fetchDetailsApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payrolls/add-page/details`
      );
      const cleanedData = response?.data?.data;

      if (response.status === 200) {
        const payRolOpt = cleanedData?.PayrollTypes?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setPayrollTypesOption(payRolOpt);

        const accountOpt = cleanedData?.AccountMasters?.map((ele) => ({
          value: ele?.ID,
          label: ele?.Name,
        }));
        setAccountMastersOption(accountOpt);

        const roundOffLeaveOpt = cleanedData?.RoundOffLevels?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setRoundOffLeavesOption(roundOffLeaveOpt);
      }
    } catch (error) {
      console.error(" Error while fetching the Details Api ", error);
    }
  };

  const [errors, setErrors] = useState({});
  console.log("errors", errors);

  const schema = Yup.object().shape({
    Code: Yup.string().required("Code is required"),
    Name: Yup.string().required("Name is required"),
    SalarySlipHead: Yup.string().required("Salary Slip Head is required"),
    PayrollType_054: Yup.number()
      .typeError("Payroll is required")
      .required("Payroll is required"),
    AccountID: Yup.number()
      .typeError("Account is required")
      .required("Account is required"),
    ComputeOn:
      formData?.ComputeOnRange === true
        ? Yup.string().required("Compute On is required")
        : Yup.string(), // If not required, still ensure it's a string

    Slabs: Yup.array().when("ComputeOnRange", {
      is: true,
      then: (schema) =>
        schema
          .of(
            Yup.object().shape({
              LineNo: Yup.number().required("Line number is required"),
              FromAmount: Yup.number().nullable(),
              ToAmount: Yup.number().nullable(),
              Formula: Yup.string().required("Formula is required"),
            })
          )
          .min(1, "At least one record is required"),
      otherwise: (schema) => schema.of(Yup.object()),
    }),

  });

  const validateField = async (fieldName, value) => {
    try {
      // Create an object for the specific field to validate
      const fieldData = { [fieldName]: value };
      const fieldSchema = Yup.object().shape({
        [fieldName]: schema.fields[fieldName],
      });

      // Validate the specific field
      await fieldSchema.validate(fieldData, { abortEarly: false }); // Ensure all validation is checked

      // Clear the error for the specific field
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Optional: Show a toast for errors specific to certain fields
        if (fieldName.startsWith("Slabs")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Unexpected validation structure:", err);
      }
    }
  };

  // Add a new slab line
  const handleAddSlabsLine = () => {
    const currentRow =
      formData.Slabs.length !== 0
        ? formData.Slabs[formData.Slabs.length - 1]
        : null;

    if (
      currentRow &&
      (currentRow.Formula === null || currentRow.Formula === "")
    ) {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    let newLineNo = 1;
    const existingLineNos = formData.Slabs.map((row) => row.LineNo);
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++;
    }

    setFormData((prevState) => ({
      ...prevState,
      Slabs: [
        ...prevState.Slabs,
        {
          LineNo: newLineNo,
          FromAmount: 0,
          ToAmount: 0,
          Formula: "",
        },
      ],
    }));
  };

  // Delete a slab line
  const handleDeleteSlabsLine = (lineNo) => {
    setFormData((prevState) => ({
      ...prevState,
      Slabs: prevState.Slabs.filter((slab) => slab.LineNo !== lineNo),
    }));
  };

  const handleSelect = async (selectedOption, name) => {
    const value = selectedOption.value;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Trigger validation for the specific field after updating
      validateField(name, value);

      return updatedData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    let newValue = value;
    if (name === "RoundOffValue") {
      // Convert to float or set empty string if invalid
      newValue = value === "" ? "" : parseFloat(value);
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    validateField(name, newValue);
  };

  const handleCheckboxChange = async (e) => {
    const { name, checked } = e.target;

    if (name === "IsBasePayroll") {
      try {
        const response = await GetServiceCaller(
          `${API_URL}payroll/check-base-payroll?payrollID=${""}`
        );

        if (response?.status === 200) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            IsBasePayroll: 1,
          }));
        } else if (response?.status === 201) {
          toast.error(response?.data?.message, {
            position: "top-right",
          });
        }
      } catch (error) {
        console.error("Error fetching Base Payroll validation API:", error);
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    }
  };

const handleSlabChange = async (e, index) => {
  const { name, type, checked, value } = e.target;
  const updatedLines = [...formData.Slabs];

  let newValue = type === "checkbox" ? checked : value;

  // Format FromAmount and ToAmount to always have 2 decimal places
  if (name === "FromAmount" || name === "ToAmount") {
    // Prevent empty string or invalid numbers from breaking formatting
    newValue = value === "" ? "" : parseFloat(value).toFixed(2);
  }

  updatedLines[index] = {
    ...updatedLines[index],
    [name]: newValue,
  };

  setFormData((prevState) => ({
    ...prevState,
    Slabs: updatedLines,
  }));

  const updatedFormData = { ...formData, Slabs: updatedLines };

  await validateField(`Slabs[${index}].${name}`, updatedFormData);
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate all fields in the schema
      await schema.validate(formData, { abortEarly: false });

      // Clear all errors on successful validation
      setErrors({});

      // Call the API to submit data
      const response = await PostServiceCaller(
        `${API_URL}payrolls`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => navigate("/rujul/hrm/payroll"), 1000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);

        // Map validation errors to fields
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
          if (err.path === "Slabs") {
            toast.error(err.message);
          }
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleComputeOnBlur = (e) => {
    const value = e.target.value;

    if (value && !(value.startsWith("[") && value.endsWith("]"))) {
      toast.error(
        "Invalid Syntax: Compute On value must be enclosed with square brackets []"
      );

      // Clear the input
      setFormData((prevData) => ({
        ...prevData,
        ComputeOn: "", // Clear only this field
      }));
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <form onSubmit={handleSubmit}>
          <div className="row row-flex">
            {/** Grid one */}
            <div className="col-md-4 flex-col mt-1">
              <div class="card">
                <div class="card-header" style={{ height: "30px !important" }}>
                  <h6 className="text-white">  Payroll Details</h6>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label className="form-label">
                          Code<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="Code"
                          placeholder="Code"
                          value={formData?.Code}
                          className={`${errors.Code ? "is-invalid" : ""
                            } form-control`}
                          onChange={handleChange}
                        />
                        {errors.Code && (
                          <div className="invalid-feedback">{errors.Code}</div>
                        )}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label className="form-label">
                          Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className={`${errors.Name ? "is-invalid" : ""
                            } form-control`}
                          value={formData?.Name}
                          onBlur={() => setFormData(prevData => ({ ...prevData, SalarySlipHead: formData?.Name }))}
                          onChange={handleChange}
                        />
                        {errors.Name && (
                          <div className="invalid-feedback">{errors.Name}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label className="form-label">Description</label>
                        <textarea
                          type="text"
                          name="Description"
                          placeholder="Description"
                          className="form-control"
                          value={formData?.Description}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label className="form-label">
                          Salary Slip Head<span className="required">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          name="SalarySlipHead"
                          placeholder="SalarySlipHead"
                          className={`${errors.SalarySlipHead ? "is-invalid" : ""
                            } form-control`}
                          value={formData?.SalarySlipHead}
                          onChange={handleChange}
                        />
                        {errors.SalarySlipHead && (
                          <div className="invalid-feedback">
                            {errors.SalarySlipHead}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">
                        Payroll Type<span className="required">*</span>{" "}
                      </label>
                      <Select
                        className={`${errors.PayrollType_054 ? "is-invalid" : ""
                          } `}
                        placeholder="Payroll Type"
                        name="PayrollType_054"
                        options={[
                          { value: "", label: "Select" },
                          ...payrollTypeOptions,
                        ]}
                        value={payrollTypeOptions?.find(
                          (o) => o.value === formData?.PayrollType_054
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                      {errors.PayrollType_054 && (
                        <div className="invalid-feedback">
                          {errors.PayrollType_054}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        Account<span className="required">*</span>
                      </label>

                      <Select
                        className={`${errors.AccountID ? "is-invalid" : ""} `}
                        options={[
                          { value: "", label: "Select" },
                          ...accountMastersOption,
                        ]}
                        value={accountMastersOption.find(
                          (o) => o.value === formData?.AccountID
                        )}
                        name="AccountID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />

                      {errors.AccountID && (
                        <div className="invalid-feedback">
                          {errors.AccountID}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-check me-3 mt-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="OnAttendance"
                          name="OnAttendance"
                          checked={formData?.OnAttendance}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label">
                          Based On Attendance
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check me-3 mt-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ShowZeroValue"
                          name="ShowZeroValue"
                          checked={formData?.ShowZeroValue}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label">
                          Show in Salary Slip if zero
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/** Grid Two */}
            <div className="col-md-4 flex-col mt-1">
              <div class="card">
                <div class="card-header" style={{ height: "30px !important" }}>
                  <h6 className="text-white" >Other Details</h6>
                </div>
                <div className="card-body">
                  <div className="row mt-1">
                    <div className="col-md-6">
                      <label className="form-label">
                        Compute On<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`${errors.ComputeOn ? "is-invalid" : ""
                          } form-control`}
                        placeholder="Compute On"
                        name="ComputeOn"
                        disabled={formData?.ComputeOnRange ? false : true}
                        value={formData?.ComputeOn}
                        onChange={handleChange}
                        onBlur={handleComputeOnBlur}
                      />
                      {errors.ComputeOn && (
                        <div className="invalid-feedback">
                          {errors.ComputeOn}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Formula</label>
                      <textarea
                        placeholder="Formula"
                        className="form-control"
                        disabled={formData?.ComputeOnRange ? true : false}
                        value={formData?.Formula}
                        name="Formula"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Round Off Level</label>
                      <Select
                        options={[
                          { value: "", label: "select" },
                          ...roundOffLeavesOption,
                        ]}
                        name="RoundOffLevel_035"
                        value={roundOffLeavesOption?.find(
                          (o) => o.value === formData?.RoundOffLevel_035
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Round Off</label>
                      <input
                        className="form-control"
                        placeholder="Round Off"
                        name="RoundOffValue"
                        value={formData?.RoundOffValue}
                        type="number"
                        step="0.01"
                        onChange={handleChange}
                      />
                    </div>

                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <div className="form-check me-3 ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="IsBasePayroll"
                          name="IsBasePayroll"
                          checked={formData?.IsBasePayroll}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label">
                          Is Base Payroll
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ComputeOnRange"
                          name="ComputeOnRange"
                          checked={formData?.ComputeOnRange}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label">
                          Compute On Range
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-1">
                    <div className="col-md-6">
                      <div className="form-check me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="IsCalculatedOnRunTime"
                          name="IsCalculatedOnRunTime"
                          checked={formData?.IsCalculatedOnRunTime}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label">
                          Is dependent on Monthly Payroll
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/** Grid Three */}
            <div className="col-md-4 flex-col mt-1">
              <div class="card">
                <div class="card-header" style={{ height: "30px !important" }}>
                  <h6 className="text-white">Suggestion Box For Formula</h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <h6>Payroll Code must be mentioned in Square Bracket.</h6>
                      <p>([Payroll Code]*10/100)</p>
                      <p>
                        <strong>Ex1:</strong> ([Basic]*10/100)
                      </p>
                      <p>
                        <strong>Ex2:</strong> ([Gross]*10/100)
                      </p>
                    </div>
                    <div className="col-md-6">
                      <h6>Note: Compute On value must be in Square Bracket.</h6>
                      <p>
                        <strong>Ex1:</strong> [Gross]
                      </p>
                      <p>
                        <strong>Ex2:</strong> [Basic] + [HRA] + [DA]
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            {/** Grid Four */}
            <div className="container">
              <div className="card">
                <div className="card-header" style={{ height: "30px !important" }}>
                  <h6 className="text-white">Payroll Slab</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive poc-head rounded ">
                    <button
                      type="button"
                      onClick={() => handleAddSlabsLine()}
                      disabled={formData?.ComputeOnRange ? false : true}
                      className={formData?.ComputeOnRange ? "custom-btn mb-2 pull-right" : " disabled-icon custom-btn mb-2 pull-right"}
                    >
                      <i className="fa fa-plus"></i>&nbsp;Add
                    </button>
                    <Table
                      id="poctable_head"
                      className="table table-bordered"
                      bordered
                      striped
                      rounded
                    >
                      <thead style={{ padding: "0px" }} className="text-center">
                        <tr>
                          <th style={{ fontSize: "15px" }}>From Amount</th>
                          <th style={{ fontSize: "15px" }}>To Amount</th>
                          <th style={{ fontSize: "15px" }}>Formula</th>
                          <th style={{ fontSize: "15px" }}>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.Slabs?.map((ele, index) => (
                          <tr key={ele.LineNo}>
                            <td>
                              <input
                                className="form-control text-end"
                                name="FromAmount"
                                value={ele.FromAmount}
                                onChange={(e) => handleSlabChange(e, index)}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control text-end"
                                name="ToAmount"
                                value={ele.ToAmount}
                                onChange={(e) => handleSlabChange(e, index)}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                name="Formula"
                                value={ele.Formula || ""}
                                onChange={(e) => handleSlabChange(e, index)}
                              />{" "}
                              {errors?.[`Slabs[${index}].Formula`] && (
                                <span className="error">
                                  {errors?.[`Slabs[${index}].Formula`]}
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <i
                                className="fa fa-trash-o mt-2 icons"
                                onClick={() =>
                                  handleDeleteSlabsLine(ele?.LineNo)
                                }
                              ></i>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-2 me-2">
            <div className="d-flex">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => navigate(`/rujul/hrm/payroll`)}
                >
                  Cancel
                </button>
              </div>
              <div>
                <button
                  disabled={loading ? true : false}
                  type="submit"
                  className=" custom-btn"
                >
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayrollAdd;
